import { render, staticRenderFns } from "./modalPhotoclaim.pug?vue&type=template&id=75fbebba&lang=pug&external"
import script from "./modalPhotoclaim.js?vue&type=script&lang=js&external"
export * from "./modalPhotoclaim.js?vue&type=script&lang=js&external"
import style0 from "./modalPhotoclaim.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75fbebba')) {
      api.createRecord('75fbebba', component.options)
    } else {
      api.reload('75fbebba', component.options)
    }
    module.hot.accept("./modalPhotoclaim.pug?vue&type=template&id=75fbebba&lang=pug&external", function () {
      api.rerender('75fbebba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modalPhotoclaim/index.vue"
export default component.exports